<template>
  <TableControlGroup :tableData="tableSet" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import TableSourceQueryGraphQL from './tablesource.query.graphql';
import TableControlGroup from '@/components/TableControlGroup/TableControlGroup.vue';
import { ITableGroup, ITableGroupColumn, ITableSection } from '@/interfaces/entities/table-group.interface';
import { toNumber } from '@/utils/convert';

const props = defineProps<{
  tableSetId: string;
  selectedCode: string;
  displayCodes: string[];
}>();

const { result: queryResult } = useQuery(TableSourceQueryGraphQL, {
  path: props.tableSetId,
});

const tableSet = computed((): ITableGroup => {
  // Clone result to avoid read only error PSR-1186
  const tableSections = JSON.parse(JSON.stringify(queryResult.value?.item?.tableSections ?? []));
  return {
    tableSections: tableSections.map((section: any) => {
      return {
        heading: section.heading,
        showMoreButton: { value: toNumber(section.showMoreButton.value) },
        initialNumberOfItemsToShow: section.initialNumberOfItemsToShow,
        showMoreButtonText: section.showMoreButtonText,
        showLessButtonText: section.showLessButtonText,
        tableColumn: section.tableColumn
          .filter((column: any) => props.displayCodes.includes(column.code?.value ?? ''))
          .map((column: any) => {
            return {
              code: column.code,
              rows: column.rows.map((row: any) => {
                // Replace tokenized content
                row.heading?.rendered && (row.heading.value = row.heading.rendered);
                row.description?.rendered && (row.description.value = row.description.rendered);
                row.tooltipContent?.rendered && (row.tooltipContent.value = row.tooltipContent.rendered);
                return {
                  heading: row.heading,
                  description: row.description,
                  percentage: row.percentage,
                  tooltipContent: row.tooltipContent,
                };
              }),
              highlighted: column.code.value == props.selectedCode,
            } as ITableGroupColumn;
          }),
      } as ITableSection;
    }),
  };
});
</script>
